<template>
	<el-container>
		<el-main class="mainWrap">
			<Header></Header>
			<div class="wrap">
				<div class="title">关于我们</div>
				<div class="content">
					<div>杭州飞长好旅游有限公司，是中国创新型旅游平台，致力于打造一个平民化的旅游平台，让旅游不再是高消费的奢侈品，让旅游不再是普通人的渴望不可及，我们要让旅游走进千家万户，让旅游成为每个人的生活方式，让人人都能轻松旅游，让人人都能每月旅游，让一亿家庭玩遍中国，让三千万家庭玩遍世界，以旅游带动经济和各地区特色产品快速流通。</div>
				</div>
			</div>
			<div class="bottom">
				<Footer></Footer>
			</div>
		</el-main>
	</el-container>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		computed: {
			
		},
		onLoad(option) {
			
		},
		created() {
			
		},
		methods: {
			
		}
	}
</script>
<style lang="scss" scoped>
	.el-main{
		padding: 0 !important;
	}
	.bottom{
		width: 100%;
		position: fixed;
		left: 0;
		bottom: 0;
	}
	.wrap{
		width: 100%;
		padding: 30px;
		box-sizing: border-box;
		.title{
			font-weight: bold;
			font-size: 30px;
			text-align: center;
		}
		.content{
			width: 100%;
			margin-top: 30px;
			>div{
				display: block;
				font-size: 20px;
				line-height: 30px;
				color: #666666;
				margin-top: 6px;
				&.ident {
					text-indent: 1em;
				}
				.blodline {
					font-weight: bold;
					text-decoration: underline;
				}
				&.subTitle{
					font-size: 30px;
					font-weight: bold;
					color: #000000;
					line-height: 60px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/about.vue